import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DEFAULT_LIMIT } from '../data/useTicketListings';
import { ClearFiltersButton } from './ClearFiltersButton';
import { InboxNavTicketRow } from './InboxNavTicketRow';
import { InboxNavTicketRowSkeleton } from './InboxNavTicketRowSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function InboxNavTicketList({
  tickets,
  loading
}) {
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      children: Array.from({
        length: DEFAULT_LIMIT
      }).map((_, i) => /*#__PURE__*/_jsx(InboxNavTicketRowSkeleton, {}, i))
    });
  }
  if (!tickets || tickets.length === 0) {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      padding: "400",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.inboxNavPanel.empty.noResults"
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.inboxNavPanel.empty.noResultsHelp"
        })
      }), /*#__PURE__*/_jsx(ClearFiltersButton, {
        screen: "ticket-details-inbox-nav"
      })]
    });
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    children: tickets.map(ticket => /*#__PURE__*/_jsx(InboxNavTicketRow, {
      ticket: ticket
    }, ticket.hs_ticket_id))
  });
}